var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLiCrAccepted = function SvgLiCrAccepted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36531 12.2477C7.92708 12.2163 6.49706 12.4724 5.1591 13.0009C3.82113 13.5294 2.60217 14.3198 1.57368 15.3256C1.18699 15.7287 0.994083 15.9311 1.00014 16.2019C1.01469 16.3251 1.05667 16.4434 1.12299 16.5482C1.18931 16.653 1.27828 16.7416 1.38336 16.8074C1.82946 16.9807 2.31212 17.0384 2.7865 16.9753H15.9441C16.4185 17.0384 16.9012 16.9807 17.3473 16.8074C17.4523 16.7416 17.5413 16.653 17.6076 16.5482C17.6739 16.4434 17.7159 16.3251 17.7305 16.2019C17.7365 15.9294 17.5436 15.7278 17.1569 15.3256C16.1285 14.3198 14.9095 13.5294 13.5715 13.0009C12.2336 12.4724 10.8035 12.2163 9.36531 12.2477Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6748 7.97069C10.3641 7.97069 11.0379 7.7663 11.6111 7.38336C12.1842 7.00043 12.6309 6.45614 12.8948 5.81933C13.1586 5.18252 13.2276 4.48177 13.0932 3.80571C12.9588 3.12964 12.627 2.50861 12.1396 2.02114C11.6523 1.53367 11.0313 1.20166 10.3553 1.06708C9.67925 0.932497 8.97849 1.00139 8.34161 1.26506C7.70474 1.52872 7.16034 1.97531 6.77726 2.54836C6.39418 3.12141 6.18962 3.79518 6.18945 4.48448C6.18934 4.94226 6.27941 5.39557 6.45451 5.81853C6.62961 6.24149 6.88633 6.62582 7.20998 6.94955C7.53364 7.27329 7.9179 7.53009 8.34081 7.7053C8.76373 7.88051 9.21702 7.97069 9.6748 7.97069Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3012 7.05464V1.86426M15.7061 4.45945H20.8964",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLiCrAccepted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/liCrAccepted.cd175a63.svg";
export { ForwardRef as ReactComponent };